import { createFileRoute } from '@tanstack/react-router';
import {
  loadUserGroupMessages,
  loadUserGroupScreens,
  userGroupDetailScreen,
  userGroupDetailSearch,
} from '@/modules/user-group/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/seguranca/grupos/$groupId/')({
  validateSearch: userGroupDetailSearch,
  staticData: { screen: userGroupDetailScreen },
  loader: () => loadUserGroupMessages(),
  component: lazyScreen(loadUserGroupScreens, 'UserGroupFormPage'),
});
